import { fetchAppAPI } from "../../utils/api";

export const login = (licenseCode) => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/auth/login"
            const data = await fetchAppAPI(params, "", { auth: false, method: "POST", body: { licenseCode } })
            resolve(data)
        } catch (e) {
            reject(e)
        }
    })
}

export const validate = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const params = "/auth/validate"
            const data = await fetchAppAPI(params, "", { method: "POST" })
            resolve(data)
        } catch (e) {
            reject(e)
        }
    })
}